import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { hireRegistrationNextStep, setHireRegistrationFormData } from '../../redux/slice/commonSlice'
import { fetchSkills } from '../../redux/action/commonAction'
import { HiringStep2 } from '../../constants/ImagePaths'
import Image from '../../components/general/Image'
import SkillCard from '../../components/hire-developer/SkillCard'
import { DoubleStar } from "../../constants/ImagePaths"
import Button from '../../components/general/Button'
import { toast } from 'react-toastify'
import Select from '../../components/general/Select'
import Input from '../../components/general/Input'
import DashedChips from '../../components/common/DashedChips'
import useDebounce from '../../hooks/useDebounce'

const SkillType = () => {
    const dispatch = useDispatch()
    const { isTechLoading, technologies } = useSelector(state => state.common.tech);
    const { hire_registration: { stepTwoData: { skills } } } = useSelector(state => state.common);
    const [displayActiveTechs, setDisplayActiveTechs] = useState([])
    const [activeTechs, setActiveTechs] = useState(new Set([]))
    const debounce = useDebounce();

    useEffect(() => {
        if (!isTechLoading) return;
        dispatch(fetchSkills(30));
        // eslint-disable-next-line
    }, [isTechLoading])

    console.log(activeTechs);
    

    const handleSkillChange = (tech, toggle) => {
        console.log(tech, toggle);
        
        const currentActiveTechs = new Set(activeTechs);
        if (toggle) {
            // Remove skill
            currentActiveTechs.delete(tech.id);
            setDisplayActiveTechs(prev => prev.filter(t => t.name !== tech.name));
        } else {
            // Add or update skill
            setDisplayActiveTechs(prev => {
                const techIndex = prev.findIndex(t => t.name === tech.name);
                if (techIndex !== -1) {
                    // Update experience if provided
                    const updated = [...prev];
                    return updated;
                } else {
                    // Add new skill
                    return [...prev, { name: tech.name }];
                }
            });
            currentActiveTechs.add(tech.id);
        }
        setActiveTechs(currentActiveTechs);

        console.log(skills);
        

        const hasSelectedSkill = skills.some(skill => skill.value === tech.id)
        
        const payload = hasSelectedSkill ? skills?.filter(p => p.value != tech.id) : [...skills, { label: tech.name, value: tech.id }]
        dispatch(setHireRegistrationFormData({
            formData: {
                skills: payload
            }
        }))
    }


    const handleChange = (value, label, actionType = 'add') => {        
        const currentActiveTechs = new Set(activeTechs);      

        if(actionType === 'remove') {
            currentActiveTechs.delete(value)
        }
        else {
            currentActiveTechs.add(value)
        }

        setActiveTechs(currentActiveTechs)
        
        const hasSelectedSkill = skills.some(skill => skill.value === value)
        
        const payload = hasSelectedSkill ? skills?.filter(p => p.value != value) : [...skills, { label: label, value: value }]
        dispatch(setHireRegistrationFormData({
            formData: {
                skills: payload
            }
        }))
    }

    const handleInputChange = (text) => {
        debounce(() => {
            dispatch(fetchSkills(30, text));
        }, 500);
    }

    const handleSubmit = () => {
        if(!skills.length) {
            toast.error('Please select at least one skill')
            return;
        }

        dispatch(hireRegistrationNextStep())
    }
    return (
        <div className="text-white py-[20px] lg:flex lg:justify-between lg:items-start lg:gap-[30px]">
            <div className="project-Image lg:w-[40%]">
                <figure>
                    <Image src={HiringStep2} alt="hire-step-img2" />
                </figure>
            </div>
            <div className="mt-[30px] lg:mt-0 lg:w-[55%]">
                <div className="text-[14px] text-primary-color">2/3</div>
                <h3 className="text-[30px] lg:text-[1.7rem] font-bold flex justify-start">
                    <span>Select the skills that matter most.</span>
                    <Image src={DoubleStar} alt="double-star" className="w-[40px] h-[40px] hidden lg:block ml-[10px]" />
                </h3>
                <p className='text-primary-color text-[0.7rem]'> Select 1–3 now, tweak anytime later</p>

                <div className='mt-[20px]'>
                    <Input 
                        placeholder='Search' 
                        onChange={handleInputChange}
                    />
                </div>
                <div className='flex flex-wrap gap-2'>
                    {
                        displayActiveTechs.map((tech, index) => (
                                tech.experience ? (
                                    <DashedChips keyName={index} text={`${tech.name}-${tech.experience} years`} />
                                ) : (
                                <DashedChips keyName={index} text={`${tech.name}`} />
                            )
                        ))
                    }
                </div>

                <div className='mt-[20px]'>
                    <h5 className="text-primary-color mb-[10px]">Popular Skills</h5>
                    
                    <div className='lg:max-h-[200px] lg:overflow-y-auto'>
                        <div className='grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 lg:gap-[10px] gap-[10px] lg:justify-start'>
                            {
                                technologies.map((tech, index) => (
                                    <div key={index}>
                                        <SkillCard 
                                            extraClass='flex-col justify-center'
                                            onClick={() => handleSkillChange(tech, activeTechs.has(tech.id))} keyName={index} icon={tech.icon_details ? tech.icon_details.file : ''} name={tech.name} isActive={activeTechs.has(tech.id)} />
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>

                <Button className='bg-primary-color text-black w-full md:w-[200px] lg:h-[50px] h-[40px] mt-[20px] rounded' disabled={!Boolean(skills.length)} onClick={handleSubmit}> Get Started </Button>
            </div>
        </div>

    )
}

export default SkillType